import React from 'react'
import { Link } from 'react-router-dom'

const formatDate = (value) => {
  if (!value) return ''
  try {
    return new Date(value).toLocaleDateString()
  } catch {
    return ''
  }
}

const DuplicateBanner = ({ user }) => {
  if (!user || user?.statusData?.value !== 'duplicate') return null

  const primaryId = user.primaryContactRef
  const sinceDate = formatDate(user.updatedAt)

  return (
    <div
      role="alert"
      style={{
        background: '#FFEBEE',
        border: '1px solid #C62828',
        color: '#7F1D1D',
        padding: '12px 16px',
        borderRadius: 8,
        marginTop: 16,
        marginBottom: 16,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        fontSize: 14,
      }}
    >
      <span role="img" aria-label="locked" style={{ fontSize: 18 }}>🔒</span>
      <div style={{ flex: 1 }}>
        <strong>Frozen — duplicate contact.</strong>{' '}
        This person is already enrolled as the primary customer
        {sinceDate ? ` (marked as duplicate on ${sinceDate})` : ''}.
        All actions on this record are disabled.
      </div>
      {primaryId && (
        <Link
          to={`/contact/${primaryId}`}
          style={{
            background: '#C62828',
            color: '#fff',
            padding: '6px 12px',
            borderRadius: 6,
            textDecoration: 'none',
            fontWeight: 500,
            whiteSpace: 'nowrap',
          }}
        >
          Open primary →
        </Link>
      )}
    </div>
  )
}

export default DuplicateBanner
